import { LOCALES, type Locale } from './locales';

/** Any BCP 47 tag onto a locale the app ships: `es-*` → Spanish, anything else → English. */
export function resolveLocale(tag: string | null | undefined): Locale {
  if (tag && (LOCALES as readonly string[]).includes(tag)) return tag as Locale;
  return tag?.toLowerCase().startsWith('es') ? 'es-ES' : 'en-US';
}
